import React, { useEffect } from "react";
// MUI Components
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
// Icons
import WarningIcon from "@material-ui/icons/Warning";

// Other Files
import { colors } from "../../constants/colors";
import { customTheme } from "../../constants/customTheme";
import classNames from "classnames";
import { wifiEnabled } from "../../constants/constants";

const useStyles = makeStyles({
  root: (props) => customTheme(props.theme).dialog.root,
  title: customTheme().dialog.title,
  contentContainer: customTheme().dialog.contentContainer,
  contentItem: customTheme().dialog.contentItem,
  buttonContainer: customTheme().dialog.buttonContainer,
  buttonPrimary: (props) => customTheme(props.theme).buttonPrimary,
  buttonOutlined: (props) => customTheme(props.theme).buttonOutlined,
  icon: {
    ...customTheme().titleIcon,
    color: (props) => colors.warning,
  },
});

const ParticipantWarningDialog = (props) => {
  const classes = useStyles(props);
  const [updateRemote, setUpdateRemote] = React.useState(false);

  useEffect(() => {
    props.fetchCheckWifi(false, false);
  }, []);

  useEffect(() => {
    if (props.wifiConnection && wifiEnabled) {
      setUpdateRemote(true);
    }
  }, [props.wifiConnection]);

  return (
    <Dialog
      open={props.open}
      PaperProps={{ className: classNames(classes.root) }}
    >
      <Typography
        className={classes.title}
        variant="h4"
        color="textPrimary"
        align="center"
      >
        <WarningIcon className={classes.icon} />
        <span>
          {props.prompt === "EXISTING_ID"
            ? "Participant ID Already In Use"
            : props.prompt === "INFO_EDITED"
            ? "Update Participant Information"
            : "Modified Protocol Previously Used For Participant"}
        </span>
      </Typography>
      <DialogContent className={classes.contentContainer}>
        <Typography
          className={classes.contentItem}
          color="textPrimary"
          align="center"
        >
          {props.prompt === "EXISTING_ID"
            ? `Participant ID is already in use. Would you like to use the existing participant with this ID or create a new ID?`
            : props.prompt === "INFO_EDITED"
            ? `You have made changes to the registered participant's information. The participant's information will be updated. Are you sure you want to update the information?
            `
            : `Participant has a previous study with a modified version of the selected protocol. Would you like to do a follow-up study using the modified protocol or continue with a new study using the original protocol?`}
        </Typography>

        {props.prompt === "INFO_EDITED" && wifiEnabled && (
          <FormControlLabel
            className={classes.testModeFormControl}
            control={
              <Checkbox
                color="primary"
                className={classes.checkbox}
                onChange={(e) => setUpdateRemote(!updateRemote)}
                checked={updateRemote}
                value={updateRemote}
              />
            }
            label="Sync participant information changes to cloud"
          />
        )}
      </DialogContent>
      {props.prompt === "EXISTING_ID" ? (
        <DialogActions className={classes.buttonContainer}>
          <Button
            onClick={() =>
              props.resolveParticipantId("USE_EXISTING", updateRemote)
            }
            variant="contained"
            color="primary"
            className={classes.buttonPrimary}
          >
            Use the Existing Participant
          </Button>
          <Button
            onClick={() =>
              props.resolveParticipantId("CREATE_NEW", updateRemote)
            }
            variant="contained"
            color="primary"
            className={classes.buttonPrimary}
          >
            Create New ID
          </Button>
        </DialogActions>
      ) : props.prompt === "INFO_EDITED" ? (
        <DialogActions className={classes.buttonContainer}>
          <Button
            onClick={() =>
              props.resolveParticipantId("DISCARD_CHANGES", updateRemote)
            }
            variant="contained"
            color="primary"
            className={classes.buttonPrimary}
          >
            Discard Changes
          </Button>
          <Button
            onClick={() =>
              props.resolveParticipantId("UPDATE_INFO", updateRemote)
            }
            variant="contained"
            color="primary"
            className={classes.buttonPrimary}
          >
            Update Information
          </Button>
        </DialogActions>
      ) : (
        <DialogActions className={classes.buttonContainer}>
          <Button
            onClick={() =>
              props.resolveParticipantId("FOLLOW_UP", updateRemote)
            }
            variant="contained"
            color="primary"
            className={classes.buttonPrimary}
          >
            Follow-Up Study
          </Button>
          <Button
            onClick={() =>
              props.resolveParticipantId("CONTINUE_NEW", updateRemote)
            }
            variant="contained"
            color="primary"
            className={classes.buttonPrimary}
          >
            New Study
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default ParticipantWarningDialog;
